import { postRequest, getRequest, deleteRequest, putRequest } from "./RequestConfig";

export const getDebiList = async (payload) => {
  try {
    const response = await postRequest(`debi/list`,payload);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAllDebiList = async (payload) => {
  try {
    const response = await postRequest(`debi/list`,payload);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getSearchedDebiList = async (payload) => {
  try {
    const response = await postRequest(`debi/search`,payload);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getSearchedDebiListAll = async (payload) => {
  try {
    const response = await postRequest(`debi/search`,payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createDebi = async (data) => {
  try {
    const response = await postRequest("debi/save", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateDebi = async (data) => {
  try {
    const response = await postRequest("debi/save", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const submitDebi = async (data) => {
  try {
    const response = await postRequest("debi/submit", data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const downloadDebi = async (id) => {
  try {
    const response = await getRequest(`debi/document/download?id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchDebiDetails = async (id, debiRegi) => {
  try {
    const response = await getRequest(`debi/details?id=${id}&registrationNumber=${debiRegi}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteDebi = async (id) => {
  try {
    const response = await deleteRequest(`debi/delete?id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelDebi = async (debiId) => {
  try {
    const response = await putRequest(`debi/cancel?id=${debiId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const editDebi = async (debiId) => {
  try {
    const response = await putRequest(`debi/edit/submittedDebi?id=${debiId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchRevisionNumber = async (debiRegi) => {
  try {
    const response = await getRequest(`debi/revisionNumber?registrationNumber=${debiRegi}`);
    return response;
  } catch (error) {
    throw error;
  }
};


